import { cn } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  tierName: string;
  className?: string;
};

const MASCOTS = [
  "iron",
  "bronze",
  "silver",
  "gold",
  "platinum",
  "emerald",
  "sapphire",
  "ruby",
  "diamond",
  "legend",
];

const Mascot: FC<Props> = ({ tierName, className }) => {
  if (!tierName || typeof tierName !== "string") return null;

  const index = MASCOTS.indexOf(tierName.split(" ")[0].toLowerCase());
  if (index < 0) return null;

  const x = ((74 + 399 * (index % 5)) / 1819) * 100;
  const y = ((93 + 440 * Math.floor(index / 5)) / 593) * 100;

  return (
    <span
      data-slot="mascot"
      aria-hidden="true"
      className={cn(
        "block bg-[url(/reward-center/mascots.png)] bg-size-[601%_263.4%] bg-no-repeat",
        className,
      )}
      style={{ backgroundPosition: `${x}% ${y}%` }}
    />
  );
};

export default Mascot;
